import { useState, useEffect, useCallback } from 'react';
import { getIsPhase1AdminStandardCohort } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-is-phase1-admin-standard-cohort/index.tsx';
import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

const JIRA_NAV4_BENEFITS_MODAL_KEY = 'jiraNav4BenefitsModal';
const MODAL_DELAY = 171_900_000; // 47.75 hours

export function useBenefitsModal(currentTime = Date.now()) {
	const [isModalShown, setModalShown] = useState(false);
	const storage = createLocalStorageProvider('jira-nav4-benefits-modal');
	const lastShown = Number(storage.get(JIRA_NAV4_BENEFITS_MODAL_KEY) || 0);

	const shouldShowModal = useCallback(() => {
		const isModalDelayFinished = lastShown + MODAL_DELAY < currentTime;
		return getIsPhase1AdminStandardCohort() && isModalDelayFinished;
	}, [currentTime, lastShown]);

	useEffect(() => {
		if (isModalShown) {
			// Update the local storage
			storage.set(JIRA_NAV4_BENEFITS_MODAL_KEY, Date.now());
		}
	}, [isModalShown, storage]);

	return { shouldShowModal, setModalShown };
}
